export const environment = {
  production: false,
  apiUrl: 'https://dev.api.insights.axpo.com',
  terrain: {
    quantizedMeshBaseUrl: 'https://3d.geo.admin.ch/ch.swisstopo.terrain.3d/v1/20250101',
    quantizedMeshApiVersion: '1.43646.0',
    wmtsBaseUrl: 'https://wmts.geo.admin.ch/1.0.0',
    wmtsLayerMap: 'ch.swisstopo.swisstlm3d-karte-farbe.3d',
    wmtsLayerAerial: 'ch.swisstopo.swissimage',
    buildingsTilesetUrl: 'https://3d.geo.admin.ch/ch.swisstopo.swissbuildings3d.3d/v1/tileset.json',
    dracoDecoderPath: 'https://www.gstatic.com/draco/versioned/decoders/1.5.6/',
  },
  auth: {
    configId: 'keycloak',
    authority: 'https://accounts.withaxpo.com/auth/realms/Axe-Lab',
    redirectUrl: window.location.origin + '/login',
    postLogoutRedirectUri: window.location.origin + '/logout',
    clientId: 'lab_insights_fe',
    scope: 'openid profile email offline_access',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    ignoreNonceAfterRefresh: true,
    triggerAuthorizationResultEvent: true,
    renewTimeBeforeTokenExpiresInSeconds: Math.floor(Math.random() * 180) + 30,
    secureRoutes: ['https://dev.api.insights.axpo.com'],
    logLevel: 2, // LogLevel.Error
  },
};
